import omit from 'lodash/omit';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const removeSensitivePropertyGroup =
  (groupName: string) => (model: Model) => {
    const existingAttributeIris =
      model.modelData.sensitivePropertyGroupsByName[groupName];

    if (existingAttributeIris) {
      setDataProperty<ModelData>(model)(
        model.modelData,
        'sensitivePropertyGroupsByName',
        omit(model.modelData.sensitivePropertyGroupsByName, groupName)
      );
    }
  };
